import React, { useEffect } from 'react'
import styles from '../styles'
import {
  withStyles,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core'
import { useSelector } from 'react-redux'
import { PatchContent, PatchData } from 'src/model/patch'
import { patchCollectionSettingsAction } from 'src/reducers/collection/action'
const MailCName = props => {
  const {
    entity,
    collectionSettings,
    dispatch,
    handleSendLinkToNewMembersOnly,
    sendLinkToNewMembersOnly,
    emailText,
    setEmailText,
    emailTitle,
    setEmailTitle,
    classes,
  } = props

  const [hasTeamsToView, setHasTeamsToView] = React.useState(false)

  const [teamListLength, setTeamListLength] = React.useState(0)
  const [memberListLength, setMemberListLength] = React.useState(0)
  const [selectedDomain, setSelectedDomain] = React.useState({
    id: '',
    domain: '',
  })
  const [domainList, setDomainList] = React.useState([])

  const domainRawList = useSelector(state => state.domain.list.results)

  const domainListCreator = () => {
    const list = []

    domainRawList.map(domain => {
      if (
        domain.defaultCollectionDto &&
        domain.defaultCollectionDto.id === entity.id &&
        domain.verificationStatus === 1
      ) {
        list.push(domain)
      }
    })
    return list
  }
  useEffect(() => {
    const result = domainRawList && domainListCreator()
    setDomainList(result)
  }, [])

  const handleSelect = event => {
    setSelectedDomain({
      id: event.target.value,
      domain: event.target.name,
    })

    const patchSource = new PatchData(null, entity.id)
    patchSource.addContent(
      new PatchContent(
        event.target.value,
        'customDomainId',
        PatchData.OPERATION_REPLACE,
      ),
    )

    dispatch(patchCollectionSettingsAction(patchSource, response => {}))
  }

  const onBlurEmailTitle = value => {
    if (collectionSettings.invite_member_subject !== value) {
      const patchSource = new PatchData(null, entity.id)
      patchSource.addContent(
        new PatchContent(
          value,
          'inviteEmailSubject',
          PatchData.OPERATION_REPLACE,
        ),
      )

      dispatch(patchCollectionSettingsAction(patchSource, response => {}))
    }
  }
  return (
    <div className={classes.customDomain_select}>
      <div className={classes.displayF}>
        <Typography color="#637381" fontWeight={500} fontSize={'14px'}>
          Choose your custom domain linked to your collection
        </Typography>
      </div>

      {domainList && domainList.length !== 0 ? (
        <FormControl variant="outlined" className={classes.formControlHalf}>
          <InputLabel id="collection-setting-custom-domain">
            Custom Domain
          </InputLabel>
          <Select
            labelId="collection-setting-custom-domain"
            id="demo-simple-select-outlined"
            value={selectedDomain.id}
            label="Custom Domain"
            onChange={event => {
              handleSelect(event)
            }}
            sx={{ backgroundColor: '#ffffff', borderRadius: '6px' }}
          >
            {domainList.map((domain, index) => {
              return (
                <MenuItem key={index} value={domain.id} name={domain.domain}>
                  {domain.domain}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
      ) : (
        <FormControl variant="outlined" className={classes.formControlHalf}>
          <InputLabel id="collection-setting-custom-domain">
            Custom Domain
          </InputLabel>
          <Select
            disabled={true}
            value={1}
            sx={{ backgroundColor: '#ffffff', borderRadius: '6px' }}
          >
            <MenuItem value={1}>
              (Default) share.minicoursegenerator.com
            </MenuItem>
          </Select>
        </FormControl>
      )}
    </div>
  )
}

export default withStyles(styles)(MailCName)
